<template>
	<div class="tcontainer">
		<Toast />
		<div class="clearfix ttitle">
			<div class="title">
				<button type="button" class="pull-right btn btn-primary" style="margin-left: 5px;" @click="downloadCSV">
					<i class="fa-solid fa-file-csv"></i>
				</button>
				Last 100 Days Average Daily X-Ray Report Range
			</div>
		</div>

		<div style="padding: 10px 0; display: flex; gap: 10px; align-items: center; flex-wrap: wrap;">
			<input type="number" step="0.01" min="0" class="form-control" style="max-width: 180px;" v-model="avgMin" placeholder="Min Avg">
			<input type="number" step="0.01" min="0" class="form-control" style="max-width: 180px;" v-model="avgMax" placeholder="Max Avg">
			<button type="button" class="btn btn-primary" @click="loadData">Apply</button>
			<button type="button" class="btn btn-secondary" @click="resetFilter">Reset</button>
		</div>

		<div class="clearfix" style="margin-bottom: 10px;">
			<div class="pull-right" style="font-weight: bold;">
				Total Centers: {{ totalRecords }}
				&nbsp; | &nbsp;
				Total Reports: {{ totalReports }}
			</div>
		</div>

		<div style="overflow-x: auto;">
			<table class="table table-bordered table-striped" style="min-width: 1200px;">
				<thead>
					<tr>
						<th>Center Id</th>
						<th>Center Name</th>
						<th>Contact Person</th>
						<th>Phone</th>
						<th>Agent</th>
						<th>First Upload</th>
						<th>Effective Days</th>
						<th>Total Reports</th>
						<th>Avg / Day</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="row in rows" :key="row.center_id">
						<td>{{ row.center_id }}</td>
						<td>{{ row.center_name }}</td>
						<td>{{ row.contact_person }}</td>
						<td>
							{{ row.phone }}
							<span v-if="row.technician_phone"> / {{ row.technician_phone }}</span>
						</td>
						<td>{{ row.agent || '-' }}</td>
						<td>{{ row.first_upload_at ? format(row.first_upload_at, 'DD/MM/YY h:mmA') : '-' }}</td>
						<td>{{ row.effective_days }}</td>
						<td>{{ row.total_reports }}</td>
						<td>{{ row.avg_daily_reports }}</td>
					</tr>
					<tr v-if="!rows.length">
						<td colspan="9" style="text-align: center;">No records found</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import Toast from 'primevue/toast';

export default {
	components: {
		Toast,
	},
	data() {
		return {
			durationDays: 100,
			avgMin: '',
			avgMax: '',
			rows: [],
			totalRecords: 0,
			totalReports: 0,
			exportRows: [],
		}
	},
	mounted() {
		this.loadData();
	},
	methods: {
		async loadData() {
			let res = await this.post('admin/load-xray-average-report-range', {
				durationDays: this.durationDays,
				avgMin: this.avgMin,
				avgMax: this.avgMax,
			});

			if (!res || !res.success) {
				this.rows = [];
				this.totalRecords = 0;
				this.totalReports = 0;
				this.exportRows = [];
				return;
			}

			this.rows = (res.rows || []).sort((a, b) => {
				if (b.avg_daily_reports != a.avg_daily_reports) return b.avg_daily_reports - a.avg_daily_reports;
				if (b.total_reports != a.total_reports) return b.total_reports - a.total_reports;
				return a.center_id - b.center_id;
			});
			this.totalRecords = Number(res.totalRecords || 0);
			this.totalReports = Number(res?.summary?.totalReports || 0);

			this.exportRows = [[
				'Center Id',
				'Center Name',
				'Contact Person',
				'Phone',
				'Agent',
				'First Upload',
				'Effective Days',
				'Total Reports',
				'Avg/Day',
			]];

			for (let row of this.rows) {
				this.exportRows.push([
					row.center_id,
					row.center_name,
					row.contact_person,
					row.technician_phone ? (row.phone + ' / ' + row.technician_phone) : row.phone,
					row.agent || '',
					row.first_upload_at || '',
					row.effective_days,
					row.total_reports,
					row.avg_daily_reports,
				]);
			}
		},
		resetFilter() {
			this.avgMin = '';
			this.avgMax = '';
			this.loadData();
		},
		downloadCSV() {
			this.exportToCSV('xray-average-range-last-100-days.csv', this.exportRows);
		},
	},
}
</script>

<style scoped>

</style>
